import { useGetLoansForRefinancing, useUpdateRefinancing } from '@src/data/api/refinancing-api'
import { ChangeEvent, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { ActionsDialog } from '../../../components'
import { CreditApplication } from '../../../data/types'
import { Refinancing } from '../../../data/types/RefinancingSchema'
import { reportErrorToConsole } from '../../../services/error-logger'
import LoanDetails from './loanDetails'

interface Props {
  creditApplication: CreditApplication
  onCancel: () => void
  open: boolean
  title: string
}

const RefinancingIcebergDialog = ({ open, creditApplication, onCancel, title }: Props) => {
  const [applyEngagement, setApplyEngagement] = useState<boolean>(
    creditApplication.refinancing?.applyEngagement ? creditApplication.refinancing?.applyEngagement : false,
  )
  const [isTotalLoss, setTotalLoss] = useState<boolean>(
    creditApplication.refinancing?.isTotalLoss ? creditApplication.refinancing?.isTotalLoss : false,
  )
  const [selectedLoan, setSelectedLoan] = useState<string>(
    creditApplication.refinancing?.originalLoanId ? creditApplication.refinancing?.originalLoanId : 'noRefinancing',
  )
  const [refinancingEligible, setRefinancingEligible] = useState<boolean>(selectedLoan !== 'noRefinancing')

  const [loans] = useGetLoansForRefinancing(creditApplication.id, open)
  const [updateRefinancing] = useUpdateRefinancing()

  useEffect(() => {
    setTotalLoss(creditApplication.refinancing?.isTotalLoss === true)
    setSelectedLoan(creditApplication.refinancing?.originalLoanId ?? 'noRefinancing')
    setApplyEngagement(creditApplication.refinancing?.applyEngagement === true)
  }, [creditApplication.refinancing])

  const handleClickTotalLoss = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.id === 'non') {
      setTotalLoss(false)
    } else {
      setTotalLoss(true)
    }
  }
  const handleEngagement = () => {
    setApplyEngagement(!applyEngagement)
  }
  const handleSelectedloan = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target
    if (value === 'noRefinancing') {
      setRefinancingEligible(false)
    } else {
      setRefinancingEligible(true)
    }
    setSelectedLoan(value)
  }

  const { handleSubmit } = useForm<CreditApplication>({
    mode: 'onBlur', // déclenche les validations Après que l'usager ait quitté le champ
    defaultValues: creditApplication,
  })

  const onConfirmData = async () => {
    const selectedRefinancing = loans.find((x) => x.loanId === selectedLoan)
    const selectedData: Refinancing = {
      versionTag: creditApplication.versionTag!,
      refinancingApplicable: refinancingEligible === true,
      isTotalLoss,
      originalLoanId: refinancingEligible === true && selectedRefinancing ? selectedRefinancing.loanId : '',
      id: creditApplication.id,
      applyEngagement: refinancingEligible === true && selectedRefinancing ? applyEngagement : true,
      amountToRefinance: 0,
      engagementRate: 0,
      engagementAmount: 0,
      creditReportUniqueNumber: '',
      cvtNumber: '',
      vin: '',
      planName: '',
    }
    try {
      await updateRefinancing(selectedData)
    } catch (error) {
      reportErrorToConsole(error)
    }
    onCancel()
  }

  return (
    <ActionsDialog
      onCancel={onCancel}
      onConfirm={handleSubmit(onConfirmData, reportErrorToConsole)}
      open={open}
      title={title}
    >
      <LoanDetails
        loans={loans}
        handleSelectedloan={handleSelectedloan}
        selectedLoan={selectedLoan}
        selectedLoss={isTotalLoss}
        handleClickTotalLoss={handleClickTotalLoss}
        handleEngagement={handleEngagement}
        applyEngagement={applyEngagement}
      />
    </ActionsDialog>
  )
}

export default RefinancingIcebergDialog
